class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
        initializeUpsell();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    //document.addEventListener('refreshCartDrawer', this.refresh.bind(this));
    document.addEventListener('refreshCartDrawer', (event) => {
    const { line, quantity, name } = event.detail;
      console.log(event.detail);
    // Call the refresh method and pass all variables
    this.refresh(line, quantity, name);
});

  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    console.log('cartupdate');
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
    document.dispatchEvent(new CustomEvent('cart-updated'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        //initializeUpsell();
        this.disableLoading(line);
      });
  }

refresh(line, quantity, name) {




 this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        //initializeUpsell();
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}



customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}






//   document.addEventListener("DOMContentLoaded", function(event) { 
//   let clearBtn = document.querySelector("#clear-discount-btn");
//   let applyBtn = document.querySelector("#apply-discount-btn");
//   let discountCodeError = document.querySelector("#discount-code-error");
//   let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
//   let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
//   let discountCodeInput = document.querySelector("#discount-code-input");
//   let totalCartSelector = document.querySelector(".totals__subtotal-value .money"); // Total Cart Selector to update the total amount. 
//   let authorization_token;
  
//   let checkoutContainer = document.createElement('div');
//   document.body.appendChild(checkoutContainer);
//   if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);
//   if(applyBtn)
//   // applyBtn.addEventListener("click", function(e){
//   //   e.preventDefault()
//   //   applyDiscount(discountCodeInput.value);
//   // });
//     document.addEventListener("click", function(event) {
//     if (event.target && event.target.id === "apply-discount-btn"){
//         console.log('hii');
//         event.preventDefault();
//         applyDiscount(discountCodeInput.value);
//     }
// });
    
//   if(clearBtn)
//   clearBtn.addEventListener("click", function(e){
//     e.preventDefault()
//     clearDiscount();
//   });
//   function clearDiscount() {
//     discountCodeValue.innerHTML = "";
//     discountCodeError.innerHTML = "";
//     clearLocalStorage();
//     fetch("/checkout?discount=%20");
//   }
//   function clearLocalStorage() {
//     if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
//     if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
//     localStorage.removeItem("discountCode");
//   }
//   function applyDiscount(code) {
//     if(applyBtn) {
//       applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
//       applyBtn.style.pointerEvents = "none";
//     }
//     fetch("/payments/config", {"method": "GET"})
//     .then(function(response) { return response.json() })
//     .then(function(data) {
//         const checkout_json_url = '/wallets/checkouts/';
//         authorization_token = btoa(data.paymentInstruments.accessToken)
//         fetch('/cart.js', {}).then(function(res){return res.json();})
//         .then(function(data){
//         let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } }
//         fetch(checkout_json_url, {
//           "headers": {
//             "accept": "*/*", "cache-control": "no-cache",
//             "authorization": "Basic " + authorization_token,
//             "content-type": "application/json, text/javascript",
//             "pragma": "no-cache", "sec-fetch-dest": "empty",
//             "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
//           },
//           "referrerPolicy": "strict-origin-when-cross-origin",
//           "method": "POST", "mode": "cors", "credentials": "include",
//           "body": JSON.stringify(body)
//       })
//       .then(function(response) { return response.json() })
//       .then(function(data) {
//         console.log(data.checkout);
//         if(data.checkout && data.checkout.applied_discounts.length > 0){
//           let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
//           fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
//           if(discountCodeWrapper) discountCodeWrapper.style.display = "inline";
//           if(discountCodeError) discountCodeError.innerHTML = "";
//          // if(discountCodeValue) 
//          // discountCodeValue.append('<li class="discounts__discount discounts__discount--end"><svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>'+ data.checkout.applied_discounts[0].title +'(-<span class="money">'+ data.checkout.applied_discounts[0].amount+'</span>)</li>')


        

//         ///  $(document).find('#Drawer-quantity-1').trigger('change');
//           let localStorageValue = {
//             'code': code.trim(),
//             'totalCart': data.checkout.total_line_items_price
//           };
//           localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
//           if(totalCartSelector) totalCartSelector.innerHTML =  data.checkout.total_price + " " + data.checkout.currency;

       
//         }else{
//           if(discountCodeValue) discountCodeValue.innerHTML = "";
//           clearLocalStorage();
//           if(discountCodeError) discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
//         }
//       }).finally(function(params) {
//         if(applyBtn){
//           applyBtn.innerHTML = "APPLY";
//           applyBtn.style.pointerEvents = "all";

//         }

//  setTimeout(function() {
//   const quantityInput = document.getElementById('Drawer-quantity-1');
//   if (!quantityInput) {
//     console.error('Quantity input not found within the line item.');
//     return;
//   }

//   // Update the quantity input value
//   quantityInput.value = 3;

//   // Dispatch a change event to trigger the onChange method of CartItems
//   quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
// }, 1000); // Adjust the delay time as needed
      
           
     
//     });
//     });
//   });
// }
// });

// document.addEventListener("DOMContentLoaded", function(event) { 
  
//   let clearBtn = document.querySelector("#clear-discount-btn");
//   let applyBtn = document.querySelector("#apply-discount-btn");
//   let discountCodeError = document.querySelector("#discount-code-error");
//   let discountCodeWrapper = document.querySelector("#applied-discount-code");
//   let discountCodeValue = document.querySelector(".applied-discount-code-span");
//   let discountCodeInput = document.querySelector("#discount-code-input");
//   let totalCartSelector = document.querySelector(".totals__subtotal-value .money"); // Total Cart Selector to update the total amount. 
//   let authorization_token;
  
//   let checkoutContainer = document.createElement('div');
//   document.body.appendChild(checkoutContainer);

//   clearBtn.style.display = "none";
  
//   if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);
//   applyBtn.addEventListener("click", function(e){
//     console.log('hii');
//     e.preventDefault()
//     applyDiscount(discountCodeInput.value);
//   });

//   if(clearBtn)
//   clearBtn.addEventListener("click", function(e){
//     e.preventDefault()
//     clearDiscount();
//   });

//   function clearDiscount() {
//     discountCodeValue.innerHTML = "";
//     discountCodeError.innerHTML = "";
//     clearLocalStorage();
//     fetch("/checkout?discount=%20");
//   }

//   function clearLocalStorage() {
//     if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
//     if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
//     localStorage.removeItem("discountCode");
//   }

//   function applyDiscount(code) {
//     console.log('hiii');
//     if(applyBtn) {
//       applyBtn.innerHTML = "Angewendet <div class='loader'></div>";
//       applyBtn.style.pointerEvents = "none";
//     }
//     fetch("/payments/config", {"method": "GET"})
//     .then(function(response) { return response.json() })
//     .then(function(data) {
//         const checkout_json_url = '/wallets/checkouts/';
//         authorization_token = btoa(data.paymentInstruments.accessToken)
//         fetch('/cart.js', {}).then(function(res){return res.json();})
//         .then(function(data){

//         let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } }
//       console.log(body.presentment_currency);
//           fetch(checkout_json_url, {
//           "headers": {
//             "accept": "*/*", "cache-control": "no-cache",
//             "authorization": "Basic " + authorization_token,
//             "content-type": "application/json, text/javascript",
//             "pragma": "no-cache", "sec-fetch-dest": "empty",
//             "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
//           },
//           "referrerPolicy": "strict-origin-when-cross-origin",
//           "method": "POST", "mode": "cors", "credentials": "include",
//           "body": JSON.stringify(body)
//       })
//       .then(function(response) { return response.json() })
//       .then(function(data) {
        
//         console.log(data.checkout);
        
//         if(data.checkout && data.checkout.applied_discounts.length > 0){
//           let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
//           fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
//           if(discountCodeWrapper) discountCodeWrapper.style.display = "flex";
//           if(discountCodeError) discountCodeError.innerHTML = "";


//           var length = data.checkout.applied_discounts.length;
//           console.log(length);
//           discountCodeValue.innerHTML = '';

//           for (let i = 0; i < length; i++) {
//             console.log(data.checkout.applied_discounts[i].title);
//     console.log("Iteration", i);
//             if (discountCodeValue) {
//               console.log('hi');
              
//     var discountHtml = '<span class="applied-discount-code-wrapper"><span class="applied-discount-code-value">' + data.checkout.applied_discounts[i].title + " (" + data.checkout.applied_discounts[i].amount + ' ' + Shopify.currency.active + ")" + '</span></span>';

//                   discountCodeValue.innerHTML += discountHtml;

            
//             }
// }
          

//           let localStorageValue = {
//             'code': code.trim(),
//             'totalCart': data.checkout.total_line_items_price
//           };
//           localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
//           if(totalCartSelector) totalCartSelector.innerHTML = "<s>" + data.checkout.total_line_items_price + " " + data.checkout.currency + "</s> " + data.checkout.total_price  + " " + data.checkout.currency;

//               clearBtn.style.display = "block";

//         }else{
//           if(discountCodeValue) discountCodeValue.innerHTML = "";
//           clearLocalStorage();
//           if(discountCodeError) discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
//         }
//       }).finally(function(params) {
//         if(applyBtn){
//           applyBtn.innerHTML = "Angewendet";
//           applyBtn.style.pointerEvents = "all";
//         }
//     });
//     });
//   });
// }

// });
  



//   document.addEventListener("DOMContentLoaded", function(event) { 
//   let clearBtn = document.querySelector("#clear-discount-btn");
//   let applyBtn = document.querySelector("#apply-discount-btn");
//   let discountCodeError = document.querySelector("#discount-code-error");
//   let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
//   let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
//   let discountCodeInput = document.querySelector("#discount-code-input");
//   let totalCartSelector = document.querySelector(".totals__subtotal-value .money"); // Total Cart Selector to update the total amount. 
//   let authorization_token;
  
//   let checkoutContainer = document.createElement('div');
//   document.body.appendChild(checkoutContainer);
//   if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);
//   if(applyBtn)
//   // applyBtn.addEventListener("click", function(e){
//   //   e.preventDefault()
//   //   applyDiscount(discountCodeInput.value);
//   // });
//     document.addEventListener("click", function(event) {
//     if (event.target && event.target.id === "apply-discount-btn") {
//         console.log('hii');
//         event.preventDefault();
//         applyDiscount(discountCodeInput.value);
//     }
// });
    
//   if(clearBtn)
//   clearBtn.addEventListener("click", function(e){
//     e.preventDefault()
//     clearDiscount();
//   });
//   function clearDiscount(){
//     discountCodeValue.innerHTML = "";
//     discountCodeError.innerHTML = "";
//     clearLocalStorage();
//     fetch("/checkout?discount=%20");
//   }
//   function clearLocalStorage() {
//     if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
//     if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
//     localStorage.removeItem("discountCode");
//   }
//   function applyDiscount(code) {
//     if(applyBtn) {
//       applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
//       applyBtn.style.pointerEvents = "none";
//     }
//     fetch("/payments/config", {"method": "GET"})
//     .then(function(response) { return response.json() })
//     .then(function(data) {
//         const checkout_json_url = '/wallets/checkouts/';
//         authorization_token = btoa(data.paymentInstruments.accessToken)
//         fetch('/cart.js', {}).then(function(res){return res.json();})
//         .then(function(data){
//         let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } }
//         fetch(checkout_json_url, {
//           "headers": {
//             "accept": "*/*", "cache-control": "no-cache",
//             "authorization": "Basic " + authorization_token,
//             "content-type": "application/json, text/javascript",
//             "pragma": "no-cache", "sec-fetch-dest": "empty",
//             "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
//           },
//           "referrerPolicy": "strict-origin-when-cross-origin",
//           "method": "POST", "mode": "cors", "credentials": "include",
//           "body": JSON.stringify(body)
//       })
//       .then(function(response) { return response.json() })
//       .then(function(data){
//         console.log(data.checkout);
//         if(data.checkout && data.checkout.applied_discounts.length > 0){
//           let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
//           fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
//           if(discountCodeWrapper) discountCodeWrapper.style.display = "inline";
//           if(discountCodeError) discountCodeError.innerHTML = "";
          
          
//           let localStorageValue = {
//             'code': code.trim(),
//             'totalCart': data.checkout.total_line_items_price
//           };
//           localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
//           if(totalCartSelector) totalCartSelector.innerHTML =  data.checkout.total_price + " " + data.checkout.currency;
//         }else{
//           if(discountCodeValue) discountCodeValue.innerHTML = "";
//           clearLocalStorage();
//           if(discountCodeError) discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
//         }
//       }).finally(function(params) {
//         if(applyBtn){
//           applyBtn.innerHTML = "APPLY";
//           applyBtn.style.pointerEvents = "all";
//         }
     
//     });
//     });
//   });
// }
// });



// document.addEventListener("DOMContentLoaded", function(event) { 
//   let clearBtn = document.querySelector("#clear-discount-btn");
//   let applyBtn = document.querySelector("#apply-discount-btn");
//   let discountCodeError = document.querySelector("#discount-code-error");
//   let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
//   let discountCodeValue = document.querySelector(".cart-drawer__footer ul.discounts.list-unstyled");
//   let discountCodeInput = document.querySelector("#discount-code-input");
//   let totalCartSelector = document.querySelector(".cart__subtotal .money"); // Total Cart Selector to update the total amount. 
//   let authorization_token;
  
//   let checkoutContainer = document.createElement('div');
//   document.body.appendChild(checkoutContainer);

//   if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);
//   if(applyBtn)
//   // applyBtn.addEventListener("click", function(e){
//   //   e.preventDefault()
//   //   applyDiscount(discountCodeInput.value);
//   // });

//   document.addEventListener("click", function(event) {
//     if (event.target && event.target.id === "apply-discount-btn") {
//         console.log(discountCodeInput.value);
//         event.preventDefault();
//       console.log(discountCodeInput.value);
//         applyDiscount(discountCodeInput.value);
//     }
// });


//   if(clearBtn)
//   clearBtn.addEventListener("click", function(e){
//     e.preventDefault()
//     clearDiscount();
//   });

//   function clearDiscount() {
//     discountCodeValue.innerHTML = "";
//     discountCodeError.innerHTML = "";
//     clearLocalStorage();
//     fetch("/checkout?discount=%20");
//   }

//   function clearLocalStorage() {
//     if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
//     if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
//     localStorage.removeItem("discountCode");
//   }

//   function applyDiscount(code) {
//       document.querySelector("#apply-discount-btn").innerHTML = "APPLYING <div class='loader'></div>";
//       document.querySelector("#apply-discount-btn").style.pointerEvents = "none";
    
//     fetch("/payments/config", {"method": "GET"})
//     .then(function(response) { return response.json() })
//     .then(function(data) {
//         const checkout_json_url = '/wallets/checkouts/';
//         authorization_token = btoa(data.paymentInstruments.accessToken)
//         fetch('/cart.js', {}).then(function(res){return res.json();})
//         .then(function(data){

//         let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } }
//         fetch(checkout_json_url, {
//           "headers": {
//             "accept": "*/*", "cache-control": "no-cache",
//             "authorization": "Basic " + authorization_token,
//             "content-type": "application/json, text/javascript",
//             "pragma": "no-cache", "sec-fetch-dest": "empty",
//             "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
//           },
//           "referrerPolicy": "strict-origin-when-cross-origin",
//           "method": "POST", "mode": "cors", "credentials": "include",
//           "body": JSON.stringify(body)
//       })
//       .then(function(response) { return response.json() })
//       .then(function(data) {
//         console.log(data.checkout);
//         if(data.checkout && data.checkout.applied_discounts.length > 0){
//           let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
//           fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
//           if(discountCodeWrapper) discountCodeWrapper.style.display = "inline";
//           if(discountCodeError) discountCodeError.innerHTML = "";
//       /// if(discountCodeValue) //discountCodeValue.innerHTML = data.checkout.applied_discounts[0].title + " (" + data.checkout.applied_discounts[0].amount + ' ' + Shopify.currency.active + ")";

//           let html = ""; // Initialize html variable
//           var length = data.checkout.applied_discounts.length;
//             for (let i = 0; i < length; i++) {
//               console.log("Iteration", i);
//               console.log('hi');
//               // Generate HTML for the discount
//               let discountHtml = '<span class="applied-discount-code-wrapper"><span class="applied-discount-code-value">' + data.checkout.applied_discounts[i].title + " (" + data.checkout.applied_discounts[i].amount + ' ' + Shopify.currency.active + ")" + '</span></span>';
//               // Append the generated HTML to the html variable
//               html += discountHtml;
//             }
          
//               // Set the html variable as the inner HTML of discountCodeValue
//               setTimeout(function() {
//               if (document.querySelector(".applied_discount")) {
//               document.querySelector(".applied_discount").innerHTML = html;
//               } else {
//               console.log("discountCodeValue element not found");
//               }
//             }, 1000); // Adjust the delay time as needed


          
//           let localStorageValue = {
//             'code': code.trim(),
//             'totalCart': data.checkout.total_line_items_price
//           };
//           localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
//           if(totalCartSelector) totalCartSelector.innerHTML =  data.checkout.total_price + " " + data.checkout.currency;



//            setTimeout(function() {
//              document.dispatchEvent(new CustomEvent('refreshCartDrawer'));
//               },5000);

          
//         }
//         else {
//           if(discountCodeValue) discountCodeValue.innerHTML = "";
//           clearLocalStorage();
//           if(discountCodeError) discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
//         }
//       }).finally(function(params) {
      
//           document.querySelector("#apply-discount-btn").innerHTML = "APPLY";
//           document.querySelector("#apply-discount-btn").style.pointerEvents = "all";
        
//     });
//     });
//   });
// }

// });




